import { map } from 'rxjs';
import { getUnixTime } from 'date-fns';
import { convertUnixToDate } from '@golden/utils';
import { AGENT_API } from '../AgentAPI';
export function createAgentDepositService(api) {
    return {
        verifyDeposit(data) {
            return api.fetch(AGENT_API.VERIFY_AGENT_DEPOSIT, { data });
        },
        deposit(data) {
            return api.fetch(AGENT_API.AGENT_DEPOSIT, { data }).pipe(map((result) => convertUnixToDate(result, 'expired_at')));
        },
        rematchDeposit(data) {
            return api.fetch(AGENT_API.REMATCH_AGENT_DEPOSIT, { data }).pipe(map((result) => convertUnixToDate(result, 'expired_at')));
        },
        getDepositResult(id) {
            return api.fetch(AGENT_API.GET_AGENT_DEPOSIT_RESULT, { config: { urlParams: { id } } }).pipe(map((result) => convertUnixToDate(result, 'expired_at')));
        },
        getDepositFee(data) {
            return api.fetch(AGENT_API.GET_AGENT_DEPOSIT_FEE, { data });
        },
        getDeposit(payload) {
            const data = {
                ...payload,
                start_at: getUnixTime(payload.start_at),
                end_at: getUnixTime(payload.end_at)
            };
            return api.fetch(AGENT_API.GET_AGENT_DEPOSIT, { data }).pipe(map((res) => ({
                ...res,
                data: res.data.map((item) => ({
                    ...convertUnixToDate(item, 'created_at', 'expired_at')
                }))
            })));
        },
        getDepositNeedRealNameMethods() {
            return api.fetch(AGENT_API.GET_AGENT_DEPOSIT_NEED_REAL_NAME_METHODS);
        }
    };
}
//# sourceMappingURL=AgentDepositService.js.map